// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: fPxG76odPsS

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import Button from "../../Button"; // plasmic-import: JUDb72ncw4_/component

import { ThemeValue, useTheme } from "./PlasmicGlobalVariant__Theme"; // plasmic-import: 40N_XXvhaC/globalVariant
import { useScreenVariants as useScreenVariantsx6JbprEhruOi } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: X6JbprEhruOi/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicInterestSelection.module.css"; // plasmic-import: fPxG76odPsS/css

import ChecksvgIcon from "./icons/PlasmicIcon__Checksvg"; // plasmic-import: -JcA6DjnTkO/icon
import Icon6Icon from "./icons/PlasmicIcon__Icon6"; // plasmic-import: DIlIifijFvS/icon

createPlasmicElementProxy;

export type PlasmicInterestSelection__VariantMembers = {};
export type PlasmicInterestSelection__VariantsArgs = {};
type VariantPropType = keyof PlasmicInterestSelection__VariantsArgs;
export const PlasmicInterestSelection__VariantProps =
  new Array<VariantPropType>();

export type PlasmicInterestSelection__ArgsType = {
  numberOfSelectedInterests?: React.ReactNode;
  interestList?: React.ReactNode;
};
type ArgPropType = keyof PlasmicInterestSelection__ArgsType;
export const PlasmicInterestSelection__ArgProps = new Array<ArgPropType>(
  "numberOfSelectedInterests",
  "interestList"
);

export type PlasmicInterestSelection__OverridesType = {
  root?: p.Flex<"div">;
  h2Headline?: p.Flex<"div">;
  h2Headline2?: p.Flex<"div">;
  interestContainer?: p.Flex<"div">;
  bottomToolbar?: p.Flex<"div">;
  submitButton?: p.Flex<typeof Button>;
};

export interface DefaultInterestSelectionProps {
  numberOfSelectedInterests?: React.ReactNode;
  interestList?: React.ReactNode;
  className?: string;
}

const $$ = {};

function PlasmicInterestSelection__RenderFunc(props: {
  variants: PlasmicInterestSelection__VariantsArgs;
  args: PlasmicInterestSelection__ArgsType;
  overrides: PlasmicInterestSelection__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const globalVariants = ensureGlobalVariants({
    theme: useTheme(),
    screen: useScreenVariantsx6JbprEhruOi()
  });

  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            plasmic_plasmic_rich_components_css.plasmic_tokens,
            plasmic_pro_pro_css.plasmic_tokens,
            sty.root,
            {
              [projectcss.global_theme_dark]: hasVariant(
                globalVariants,
                "theme",
                "dark"
              ),
              [sty.rootglobal_theme_dark]: hasVariant(
                globalVariants,
                "theme",
                "dark"
              )
            }
          )}
        >
          <div
            className={classNames(projectcss.all, sty.freeBox__kgSCn, {
              [sty.freeBoxglobal_theme_dark__kgSCnOIz4X]: hasVariant(
                globalVariants,
                "theme",
                "dark"
              )
            })}
          >
            <div
              data-plasmic-name={"h2Headline"}
              data-plasmic-override={overrides.h2Headline}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.h2Headline,
                {
                  [sty.h2Headlineglobal_theme_dark]: hasVariant(
                    globalVariants,
                    "theme",
                    "dark"
                  )
                }
              )}
            >
              {hasVariant(globalVariants, "screen", "tablet")
                ? "To show you how HubHub works, \nwe will create your first Hub for you, "
                : "To show you how HubHub works, we will \ncreate your first Hub for you, "}
            </div>
            <div
              data-plasmic-name={"h2Headline2"}
              data-plasmic-override={overrides.h2Headline2}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.h2Headline2,
                {
                  [sty.h2Headline2global_theme_dark]: hasVariant(
                    globalVariants,
                    "theme",
                    "dark"
                  )
                }
              )}
            >
              {"based on some of your interests"}
            </div>
            <p.Stack
              as={"div"}
              data-plasmic-name={"interestContainer"}
              data-plasmic-override={overrides.interestContainer}
              hasGap={true}
              className={classNames(projectcss.all, sty.interestContainer, {
                [sty.interestContainerglobal_theme_dark]: hasVariant(
                  globalVariants,
                  "theme",
                  "dark"
                )
              })}
            >
              {p.renderPlasmicSlot({
                defaultContents: null,
                value: args.interestList
              })}
            </p.Stack>
          </div>
          <div
            data-plasmic-name={"bottomToolbar"}
            data-plasmic-override={overrides.bottomToolbar}
            className={classNames(projectcss.all, sty.bottomToolbar, {
              [sty.bottomToolbarglobal_theme_dark]: hasVariant(
                globalVariants,
                "theme",
                "dark"
              )
            })}
          >
            <div
              className={classNames(projectcss.all, sty.freeBox__sgFUm, {
                [sty.freeBoxglobal_theme_dark__sgFUmOIz4X]: hasVariant(
                  globalVariants,
                  "theme",
                  "dark"
                )
              })}
            >
              {p.renderPlasmicSlot({
                defaultContents: (
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__a8FCx
                    )}
                  >
                    {"2  selected"}
                  </div>
                ),
                value: args.numberOfSelectedInterests,
                className: classNames(sty.slotTargetNumberOfSelectedInterests, {
                  [sty.slotTargetNumberOfSelectedInterestsglobal_theme_dark]:
                    hasVariant(globalVariants, "theme", "dark")
                })
              })}
            </div>
            <Button
              data-plasmic-name={"submitButton"}
              data-plasmic-override={overrides.submitButton}
              className={classNames("__wab_instance", sty.submitButton, {
                [sty.submitButtonglobal_theme_dark]: hasVariant(
                  globalVariants,
                  "theme",
                  "dark"
                )
              })}
              color={
                hasVariant(globalVariants, "theme", "dark")
                  ? "lightBlue"
                  : "darkBlue"
              }
              size={"compact"}
              submitsForm={true}
            >
              {"Next"}
            </Button>
          </div>
        </div>
      </div>
    </React.Fragment>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "h2Headline",
    "h2Headline2",
    "interestContainer",
    "bottomToolbar",
    "submitButton"
  ],
  h2Headline: ["h2Headline"],
  h2Headline2: ["h2Headline2"],
  interestContainer: ["interestContainer"],
  bottomToolbar: ["bottomToolbar", "submitButton"],
  submitButton: ["submitButton"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  h2Headline: "div";
  h2Headline2: "div";
  interestContainer: "div";
  bottomToolbar: "div";
  submitButton: typeof Button;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicInterestSelection__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicInterestSelection__VariantsArgs;
    args?: PlasmicInterestSelection__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicInterestSelection__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicInterestSelection__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicInterestSelection__ArgProps,
          internalVariantPropNames: PlasmicInterestSelection__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicInterestSelection__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicInterestSelection";
  } else {
    func.displayName = `PlasmicInterestSelection.${nodeName}`;
  }
  return func;
}

export const PlasmicInterestSelection = Object.assign(
  // Top-level PlasmicInterestSelection renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    h2Headline: makeNodeComponent("h2Headline"),
    h2Headline2: makeNodeComponent("h2Headline2"),
    interestContainer: makeNodeComponent("interestContainer"),
    bottomToolbar: makeNodeComponent("bottomToolbar"),
    submitButton: makeNodeComponent("submitButton"),

    // Metadata about props expected for PlasmicInterestSelection
    internalVariantProps: PlasmicInterestSelection__VariantProps,
    internalArgProps: PlasmicInterestSelection__ArgProps,

    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicInterestSelection;
/* prettier-ignore-end */
